// extracted by mini-css-extract-plugin
module.exports = {"CreateDevice":"ModalComponent_CreateDevice__2eHX3"};